import { connect } from 'react-redux'
import Component from '../component'
import { hideIntro, setIntroLoaded } from '../../redux/actions'
require('./style.less')

/**
 * Component that adds a video tag to the game which plays the intro-movie.
 */
@connect(state => ({
  loadedLocale: state.session.loadedLocale
}), { hideIntro, setIntroLoaded })
export default class IntroVideo extends Component {
  state = { showPrompt: false }

  componentDidMount() {
    super.componentDidMount()
    this.vidEl.play().catch(() => {
      this.setState({ showPrompt: true })
    })
    window.addEventListener('touchend', this.onClick)

    window.addEventListener('mousedown', this.onClick)

    this.vidEl.addEventListener('timeupdate', this.onProgress)

    this.srcEl.addEventListener('error', this.onError)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loadedLocale !== this.props.loadedLocale) {
      this.forceUpdate()
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount()
    this.cooldownTimer && clearTimeout(this.cooldownTimer)
    this.srcEl.removeEventListener('error', this.onError)
    window.removeEventListener('touchend', this.onClick)
    window.removeEventListener('mousedown', this.onClick)
  }

  onError = () => {
    this.onDownloaded()
    this.props.hideIntro()
  }

  onClick = () => {
    if (this.cooldown) {
      return
    }
    this.cooldown = true

    this.cooldownTimer = setTimeout(() => {
      delete this.cooldownTimer
      delete this.cooldown
    }, 100)

    if (this.state.showPrompt) {
      this.setState({ showPrompt: false }, () => {
        this.vidEl.play()
      })
    } else {
      window.removeEventListener('touchend', this.onClick)
      window.removeEventListener('mousedown', this.onClick)
      this.onEnded()
    }
  }

  onProgress = () => {
    if (this.vidEl.buffered.length && this.vidEl.duration &&
      this.vidEl.buffered.end(0) === this.vidEl.duration) {
      this.onDownloaded()
    }
  }

  onDownloaded = () => {
    if (!this.downloaded) {
      this.downloaded = true
      this.vidEl.removeEventListener('timeupdate', this.onProgress)
      this.props.setIntroLoaded(true)
    }
  }

  onEnded = () => {
    this.onDownloaded()
    this.setState({ fadeOut: true }, () => {
      setTimeout(() => {
        this.props.hideIntro()
      }, 1500)
    })
  }

  render() {
    const { IntroMovie, loadedLocale } = this.props
    const { showPrompt, fadeOut } = this.state || {}
    return (
    <div key="video" className={"introMovieContainer" + (fadeOut ? ' fadeOut' : '')} onClick={this.onClick} >
      <video onEnded={this.onEnded} preload ref={e => this.vidEl = e}
        className="introMovieVideo" >
        <source src={IntroMovie} type="video/mp4" ref={e => this.srcEl = e} />
      </video>
      { !showPrompt && (
        <div className="introVideoSkip">
          { this.t('ui.skip') }
        </div>
      )}
      { showPrompt && loadedLocale && (
        <div className="introPromptBackground">
          <div className="introPromptText">
            { this.t('ui.clicktocontinue') }
          </div>
        </div>
      )}
    </div>
    )
  }
}
